import Indicador from "..";
import ASEditFields from "./components/ASEditFields";
import { ASParamFields } from "./components/ASParamFields";
import asReport from "./reports";
import asReportSummary from "./reports/summary";

export default class AS extends Indicador {
    static get fullName() {
        return "Arranquio de Soqueira";
    }

    static get abbrev() {
        return "AS";
    }

    static get legacyApontamentoMap() {
        return {
            dataHoraEES: {
                newField: "date",
                convert: this.parseLegacyDate,
            },

            tipo: "tipo",
            talhao: "talhao",
            trator: "trator",
            frente: "frente",

            turno: "turno",

            coletas: {
                type: Array,
                newField: "coletas",
                children: {
                    qtdCanasAvaliados: "avaliados",
                    tocosArrancados: "arrancados",
                    arranquio: "arranquio",
                    descricao: "observacao",
                    foto: {
                        newField: "image.uid",
                        convert: this.convertLegacyImageUid,
                    },
                    confirmaRelatorio: "confirmaRelatorio",
                    "foto.georeferencia": "georeferencia",
                    georeferencia: "georeferencia",
                },
            },

            conformidadeAmostra: "conformidade",

            observacaoAmostra: "observacao",

            itensColeta: "images",
        };
    }

    static get legacyParamMap() {
        return {
            metaArraquioSoqueiraManual: "manual.meta",

            metaArraquioSoqueiraMecanizado: "mecanizado.meta",

            itens: {
                type: Array,
                newField: "items",
                paramMap: {
                    ASclassificacao: "classificacao",
                    ASclassificacaoIntervaloMin: "intervaloMin",
                    ASclassificacaoIntervaloMax: "intervaloMax",
                    sinalIntervaloMin: "sinalIntervaloMin",
                    sinalIntervaloMax: "sinalIntervaloMax",
                },
            },
        };
    }

    static paramFields(tipoIndicadorField = '') {
        return <ASParamFields tipoIndicadorField={tipoIndicadorField} />
    }

    static getEditFields(visita, isNew, TipoClass) {
        return <ASEditFields visita={visita} TipoClass={TipoClass} />
    }

    async renderReport(visita) {
        return asReport(this, visita);
    }

    async renderReportSummary(visita, tipoName) {
        return asReportSummary(this, visita, tipoName);
    }

    static calcConformidade(apontamento, params) {
        const f = parseFloat;

        if (!apontamento.coletas || !params || apontamento.coletas.length === 0) {
            return 0;
        }

        const total = apontamento.coletas.length;
        let sumArranquio = 0;

        for (const coleta of apontamento.coletas) {
            // 'avaliados' deve ser um número != 0.
            if (coleta.arrancados && f(coleta.avaliados)) {
                coleta.arranquio = (100 * f(coleta.arrancados)) / f(coleta.avaliados);
                sumArranquio += coleta.arranquio;

                coleta.arranquio = f(coleta.arranquio).toFixed(2);
            } else {
                coleta.arranquio = "0.00";
            }
        }

        return (sumArranquio / total).toFixed(2);
    }

    static getConformidadeStatus(conformidade, meta) {
        return this.calcConformidadeStatusInverte(conformidade, meta, 110, 100, 90);
    }
    static getTableRelApontamentos(paramsCliente, IndicadorClass) {
        return [
            { title: "Data", width: 'auto', getValue: (a) => a.dataRef.split("-").reverse().join('/') },
            { title: "Laudo", field: "laudoRef.sequencialIndex", width: 28 },
            { title: "Cod.", field: "laudoRef.fazenda.codFazenda", width: 'auto' },
            { title: "Fazenda", field: "laudoRef.fazenda.nomeFazenda" },

            { title: "Talhão", field: "talhao.nome" },

            { title: "Frota", field: "trator.numeroFrotaTrator", width: 'auto' },
            { title: "Frente", field: "frente", width: 'auto' },
            {
                title: "Operador", width: 'auto', getValue: (a) => {
                    if (a.operador && a.operador.operador) return a.operador.operador
                    if (typeof a.operador === "string" && a.operador) return a.operador
                    return "-"
                }
            },
            { title: "Turno", field: "turno", width: 'auto' },//

            {
                title: "Tocos Arrancados", width: 'auto', getValue: (a) => {
                    let sun = a.coletas?.reduce((total, c) => total += parseInt(c.arrancados), 0)
                    return sun
                }
            },
            {
                title: "Tocos Avaliados", width: 'auto', getValue: (a) => {
                    let sun = a.coletas?.reduce((total, c) => total += parseInt(c.avaliados), 0)
                    return sun
                }
            },


            {
                title: "Conf.(%)", field: "conformidade", width: 38, getColor: a => {
                    return IndicadorClass.getColorStatus(IndicadorClass.getConformidadeStatus(a.conformidade, paramsCliente?.meta))
                }
            },

        ]
    }

    static getResultStr(apontamento) {
        let tocosArrancados = apontamento.coletas?.reduce((total, c) => total += parseInt(c.arrancados), 0)
        let tocosAvaliados = apontamento.coletas?.reduce((total, c) => total += parseInt(c.avaliados), 0)

        return "Tocos Arrancados: " + tocosArrancados +
            " e Tocos Avaliados: " + tocosAvaliados
    }
}
